import OmsSolutions from "@/components/omsSolutions";
import { UTILIZATION_CONSTANTS } from "./constants";

const UtilizationComp = () => {
  return <OmsSolutions {...UTILIZATION_CONSTANTS} />;
};

export default UtilizationComp;
